export const ActionType = {
  USER_NAME: "USER_NAME",
  SET_USER_NAME: "SET_USER_NAME",
  PROJECT_NAME: "PROJECT_NAME",
  SET_PROJECT_NAME: "SET_PROJECT_NAME",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  TOKEN_REFRESHED: "TOKEN_REFRESHED",
};
